import React from 'react';

import './Newsletter.css';

const Newsletter = () => (
  <div>
   
  </div>
);

export default Newsletter;
